import { Breadcrumb, Upload, Typography, Modal, Row, Col, Button, Space, Radio, Card, Input, Select, Popconfirm, Switch, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { InboxOutlined, PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
const { Title, Paragraph, Text, Link } = Typography;
const { TextArea } = Input;
const AdminLessonModal = (props) => {
    const [messageApi, contextHolder] = message.useMessage();
    const [lesson_category, set_lesson_category] = useState([]);
    useEffect(() => {
        axios
            .get('/cramSchool/api/lesson_category')
            .then((response) => {
                set_lesson_category(response.data.data.map(map_item => {
                    return {
                        value: map_item.lesson_category_id,
                        label: map_item.name,
                    };
                }))

            })
    }, [])
    useEffect(() => {
        // console.log(props.editcard.lesson_class_data);
        if (props.editcard.lesson_category_data == undefined)
            props.setEditCard(prev => ({
                ...prev,
                lesson_category_data: [{
                    lesson_category_id: prev.lesson_id,
                    lesson_category_name: prev.label_name,
                }]
            })
            )
    }, [props.editcard])
    return (
        <>
            {contextHolder}
            <Modal
                // width={'auto'}
                style={{ pointerEvents: 'auto' }}
                open={props.open}
                onOk={props.handleOk}
                bodyStyle={{ backgroundColor: props.edit ? '#faf6f5' : '##FCF5F6' }}
                width={400}
                footer={false}
                className="modalStyle2"
                wrapClassName={"modalStyle2"}
                modalRender={(e) => <>
                    <div style={{ backgroundColor: props.edit ? '#faf6f5' : '#FCF5F6', padding: '20px', borderTop: `solid #${props.color} 5px ` }}>
                        <Row gutter={[10, 10]} >
                            <Col span={24}>
                                <Row justify="space-between" align={'bottom'}>
                                    {props.edit ?
                                        <>
                                            <img style={{ position: 'relative' }} width="35%" height="35%" src='/cram_school/edit.png'></img>
                                        </> :
                                        <>
                                            <img style={{ position: 'relative' }} width="35%" height="35%" src='/cram_school/add.png'></img>
                                        </>}
                                    <Col style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 45, left: 25 }} >{props.title}</Col>
                                    <Col>
                                        {props.edit ?
                                            <>
                                                {/* <Button style={{ backgroundColor: '#FCF5F6' }}>
                                                    <Row>
                                                        <Col>
                                                            <img width="40%" src='/cram_school/trashicon.png'></img>
                                                        </Col>
                                                        <Col>
                                                            <span>刪除貼文</span>
                                                        </Col>
                                                    </Row>
                                                </Button> */}
                                            </> :
                                            <>
                                                {/* <Button style={{ backgroundColor: '#f4fedc' }}>
                                                <Row>
                                                    <Col>
                                                        <img width="50%" src='/cram_school/addicon.png'></img>
                                                    </Col>
                                                    <Col>
                                                        <span>批次新增</span>
                                                    </Col>
                                                </Row>
                                            </Button> */}
                                            </>
                                        }
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Row gutter={[8, 8]} align={'middle'}>
                                    <Col span={6}>
                                        課程分類名稱
                                    </Col>
                                    <Col span={18}>
                                        <Select
                                            style={{
                                                width: '100%',
                                            }}
                                            labelInValue
                                            value={props.editcard.lesson_category_name}
                                            placeholder='請選擇課程分類（必填）'
                                            name="title"
                                            onChange={value => props.setEditCard(pre => {
                                                return ({
                                                    ...pre,
                                                    lesson_category_name: value.label,
                                                    lesson_category_data: [{
                                                        lesson_category_id: value.value,
                                                        lesson_category_name: value.label,

                                                    }]
                                                })
                                            })}
                                            options={lesson_category}>
                                        </Select>
                                    </Col>
                                    <Col span={6}>
                                        課程名稱
                                    </Col>
                                    <Col span={18}>
                                        <Input placeholder={'請輸入課程名稱（必填）'} type='text' value={props.editcard.name} name="name"
                                            onChange={e => props.setEditCard(pre => {
                                                return ({
                                                    ...pre,
                                                    name: e.target.value
                                                })
                                            })}
                                            autoComplete='off' />
                                    </Col>
                                    <Col span={6}>
                                        課程大綱
                                    </Col>
                                    <Col span={18}>
                                        <TextArea rows={3} placeholder={'請輸入課程大綱'} type='text' value={props.editcard.outline} name="outline"
                                            onChange={e => props.setEditCard(pre => {
                                                return ({
                                                    ...pre,
                                                    outline: e.target.value
                                                })
                                            })}
                                            autoComplete='off' />
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Row gutter={[10, 10]} justify={"center"}>
                                    <Col>
                                        <Button size='large' style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={(e) => props.setOpen(false)} block>取消</Button>
                                    </Col>
                                    <Col >
                                        <Button onClick={e => { props.edit ? props.handleEdit() : props.handleSubmit() }} size='large' style={{ background: props.edit ? `#${props.color}` : 'rgba(232, 79, 117, 1)', color: '#ffffff' }} block>{props.edit ? '修改' : '送出'}</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div >
                </>}
                centered
            >
            </Modal >
        </>
    )

}
export default AdminLessonModal;